import React from 'react'
import { useStatsJoueursDataContext } from '../../../contexts/StatsJoueursDataContext'
import { StatsJoueurRow } from '../StatsJoueurRow'
import { STATS_JOUEUR_CONFIG } from '../../../config/statsJoueurConfig'
import { CompetitionSearchNoResult } from '../../../components/CompetitionSearchNoResult'

export const SinglePage = () => {
    const { rows, page } = useStatsJoueursDataContext()

    if (rows.length <= STATS_JOUEUR_CONFIG.PAGE_SIZE * (page - 1)) {
        return <CompetitionSearchNoResult />
    }

    return (
        <div>
            {rows
                .slice(
                    STATS_JOUEUR_CONFIG.PAGE_SIZE * (page - 1),
                    STATS_JOUEUR_CONFIG.PAGE_SIZE * page,
                )
                .map((x) => (
                    <StatsJoueurRow key={x.individuId} data={x} />
                ))}
        </div>
    )
}
